/**
 * В API существуют некоторые значения, которые приходят либо числом, либо строкой.
 * Эта функция для десериализации таких значений
 */
export default function stringOrNumberDeserializer(value: string | number): string | number {
  if (typeof value === 'string') {
    return value;
  } else {
    return value;
  }
}
